import hcSticky from 'hc-sticky';
export default class StickyColumn {
  init() {
    this.initSticky();
  }

  initSticky() {
    this.blocks = document.querySelectorAll('.sticky-column');

    if (!this.blocks.length) return;

    this.blocks.forEach((block) => {
      const wrapper = document.querySelector('.sticky-column__wrapper');

      new hcSticky(wrapper, {
        stickTo: block,
        top: 150,
        bottomEnd: 50,
        responsive: {
          1024: {
            disable: true,
          },
        },
      });
    });
  }
}
